import { postDetails } from "../../services/http/http.service"
import APIList from "../../utils/constants/APIList"
import { APIResponseCodes } from "../../utils/constants/keys.constants"
import { hideLoader } from "../Loader/loader.slice"
import store from "../store"
import { setHealthChartData, setInitLineChart, setInitPieChart, setUsageChartData } from "./chartState.slice"

export const getAPIStatisticsChart = (payload: any) => {
    return async (dispatch: any) => {
        dispatch(setInitLineChart(false))
        try {
            const response = await postDetails(APIList.GET_API_USAGE_STATISTICS, payload, () => store.dispatch(getAPIStatisticsChart(payload)))
            
            if (response.statusCode === APIResponseCodes.SUCCESS) {
                dispatch(setUsageChartData({dates: response.data.dates, hits: response.data.hitsDetails}))
                dispatch(setInitLineChart(true))
                return response.data
            } else {
                dispatch(setInitLineChart(true))
                return null
            }

        } catch (error) {
            dispatch(hideLoader())
            console.log(error)
            return null
        }
    }
}

export const getAPIHealthChart = (payload: any) => {
    return async (dispatch: any) => {
        try {
            const response = await postDetails(APIList.GET_API_HEALTH_STATISTICS, payload, () => store.dispatch(getAPIHealthChart(payload)))
        
            if (response.statusCode === APIResponseCodes.SUCCESS) { 
                const temp: Array<any> = []
                temp.push({ name: 'Success', y: response.data.successResults })
                temp.push({ name: 'Failure', y: response.data.errorResults })
                dispatch(setHealthChartData({ data: temp, total: response.data.totalHits }))
                dispatch(setInitPieChart(true))
                return response.data
            } else {
                return null
            }

        } catch (error) {
            dispatch(hideLoader())
            console.log(error)
            return null
        }
    }
}